/** AI Chat roles */
export const CHAT_ROLES = {
    user: 'user',
    assistant: 'assistant',
    system: 'system',
};
